<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <span v-if="chapter">
        <span class="slide">*NOTE:Question And Option Image File size Should be less than
          {{ imagesize_new }} KB And It Should be in
          <span v-for="(img, index) in imagetype_new" :key="index">
            {{ img.imagetype }} </span>Format!!!</span>
        <v-row dense justify="center"><strong>Question No. {{ question_size }}</strong></v-row>
        <v-card class="box">
          <v-row justify="center">
            <span v-if="imageSizeFlag">
              <v-col cols="12" xs="12" sm="12">
                <p class="slide">
                  Question File size should be less than {{ imagesize_new }}KB!
                </p>
              </v-col>
            </span>
            <span v-if="imageTypeFlag">
              <v-col cols="12" xs="12" sm="12">
                <p class="slide">
                  Question File in
                  <span v-for="(img, index) in imagetype_new" :key="index">
                    {{ img.imagetype }}
                  </span>
                  Format!!!
                </p>
              </v-col>
            </span>
          </v-row>
          <div>
            <!-- <v-col cols="12" sm="1" md="1"> -->
            <!-- <v-checkbox color="#0F2027" v-model="isapprove" class="mx-2" label="Is Approve"></v-checkbox> -->
            <v-btn icon @click="showEditor" style="float: right">
              <v-icon title="CK Text Editor" color="black">mdi-file-edit-outline</v-icon></v-btn>
            <!-- </v-col> -->
          </div>
          <!-- <v-row justify="center">
            <v-col cols="12" sm="3">
              <v-text-field
                color="#0F2027"
                label="Marks"
                v-model.trim="weightage"
                type="number"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
            </v-col>
            <v-col cols="12" sm="7" md="7">
              <ckeditor v-model="question" :config="editorConfig"></ckeditor>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-col cols="12" sm="10">
                <v-file-input
                  v-model="qfile"
                  id="file"
                  prepend-icon="mdi-attachment"
                  label="Choose File"
                  show-size
                  name="doc"
                  @change="validateFile()"
                ></v-file-input>
              </v-col>
            </v-col>
          </v-row> -->
          <v-row dense>
            <!-- <v-col cols="12" md="2" sm="2"></v-col> -->
            <v-col cols="12" sm="1" md="1">
              <v-text-field color="#0F2027" label="Marks" v-model.trim="weightage" type="number"
                required></v-text-field>
            </v-col>
            <v-col cols="12" sm="1" md="1"></v-col>

            <v-col cols="12" sm="5" md="5">
              <!-- <ckeditor v-model="question" :config="editorConfig"></ckeditor> -->
              <v-textarea label="Question Title" auto-grow v-model="question" outlined rows="3"></v-textarea>
            </v-col>
            <v-col cols="12" sm="1" md="1"></v-col>
            <v-col cols="12" sm="3" md="3">
              <v-file-input v-model="qfile" id="file" prepend-icon="mdi-attachment" label="Choose File" show-size
                accept="image/*" @change="validateFile()"></v-file-input>
              <!-- name="doc" -->
              <!-- @change="validateFile()"    -->
            </v-col>
          </v-row>
        </v-card>
        <!-- <v-card class="box">
          <v-row justify="center">
            <span v-if="imageSizeFlag1">
              <v-col cols="12" md="12" sm="12">
                <p class="slide">
                  Option1 File size should be less than {{ imagesize_new }}KB!
                </p>
              </v-col>
            </span>
            <span v-if="imageTypeFlag1">
              <v-col cols="12" md="12" sm="12">
                <p class="slide">
                  Option1 File in
                  <span v-for="(img, index) in imagetype_new" :key="index">
                    {{ img.imagetype }}
                  </span>
                  Format!!!
                </p>
              </v-col>
            </span>
          </v-row>
          <v-row>
            <v-col cols="12" sm="2" md="2"> Option 1 </v-col>
            <v-col cols="12" sm="7" md="7">
              <ckeditor v-model="option_01" :config="editorConfig"></ckeditor>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-row>
                <v-col cols="12">
                  <v-file-input
                    v-model="optfile1"
                    prepend-icon="mdi-attachment"
                    label="Choose File"
                    id="file1"
                    show-size
                    name="doc"
                    @change="validateFile1()"
                  ></v-file-input>
                </v-col>
                <v-col cols="12">
                  <input
                    type="radio"
                    class="radiospace"
                    id="a"
                    value="a"
                    v-model="iscorrect_01"
                    @change="radio(iscorrect_01)"
                  />
                  <label for="a">Correct Answer</label>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card> -->
        <!-- <v-card class="box">
          <v-row justify="center">
            <span v-if="imageSizeFlag2">
              <v-col cols="12" md="12" sm="12">
                <p class="slide">
                  Option2 File size should be less than {{ imagesize_new }}KB!
                </p>
              </v-col>
            </span>
            <span v-if="imageTypeFlag2">
              <v-col cols="12" md="12" sm="12">
                <p class="slide">
                  Option2 File in
                  <span v-for="(img, index) in imagetype_new" :key="index">
                    {{ img.imagetype }}
                  </span>
                  Format!!!
                </p>
              </v-col>
            </span>
          </v-row>
          <v-row>
            <v-col cols="12" sm="2" md="2"> Option 2 </v-col>
            <v-col cols="12" sm="7" md="7">
              <ckeditor v-model="option_02" :config="editorConfig"></ckeditor>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-row>
                <v-col cols="12">
                  <v-file-input
                    v-model="optfile2"
                    prepend-icon="mdi-attachment"
                    id="file2"
                    label="Choose File"
                    show-size
                    name="doc"
                    @change="validateFile2()"
                  ></v-file-input>
                </v-col>
                <v-col cols="12">
                  <input
                    type="radio"
                    class="radiospace"
                    id="b"
                    value="b"
                    v-model="iscorrect_01"
                    @change="radio(iscorrect_01)"
                  />
                  <label for="b">Correct Answer</label>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card> -->
        <v-form id="profile_form" @submit.prevent="submit">
          <v-card class="box" v-for="(input, index) in inputs" in :key="index">
            <!-- <v-row dense>
              <v-col cols="12" sm="2" md="2">
                Option {{ index + 3 }}<br />
                <v-btn
                  color="red"
                  fab
                  small
                  dark
                  @click="deleteRow(index)"
                  class="del"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" sm="7" md="7">
                <ckeditor
                  v-model="input.text"
                  :config="editorConfig"
                ></ckeditor>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-row>
                  <v-col cols="12">
                    <v-file-input
                      v-model="input.file"
                      @change="validateFile3(input.file, index)"
                      prepend-icon="mdi-attachment"
                      label="Choose File"
                      show-size
                      name="doc"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="12">
                    <input
                      type="radio"
                      id="c"
                      value="c"
                      class="radiospace"
                      @change="radio(index)"
                      v-model="input.value"
                      :checked="input.value"
                    />
                    <label>Correct Answer</label>
                  </v-col>
                </v-row>
              </v-col>
            </v-row> -->
            <v-row dense>
              <v-col cols="12" sm="2" md="2">
                Option {{ index + 1 }}<br />
                <v-btn color="red" fab small dark @click="deleteRow(index)" class="del" v-if="index >= 2">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" sm="5" md="5">
                <!-- <ckeditor v-model="input.text" :config="editorConfig"></ckeditor> -->
                <v-textarea label="Option" auto-grow v-model="input.text" outlined rows="3"></v-textarea>
              </v-col>
              <v-col cols="12" md="1" sm="1"></v-col>
              <v-col cols="12" sm="3" md="3">
                <v-row dense>
                  <!-- <v-col cols="12"> -->
                  <v-file-input v-model="input.file" @change="validateFileOptions(input.file, index)"
                    prepend-icon="mdi-attachment" label="Choose File" show-size name="optfile"
                    accept="image/*"></v-file-input>
                  <!-- </v-col> -->
                </v-row>
                <v-row dense>
                  <!-- <v-col cols="12"> -->
                  <input type="radio" class="radiospace" @change="radio(index)" v-model="input.value"
                    :checked="input.value" />
                  <label class="ml-3">Correct <span class="ml-2">Answer</span>
                  </label>

                  <!-- </v-col> -->
                </v-row>
              </v-col>
            </v-row>
          </v-card>
          <div v-show="optionsize <= 3">
            <v-btn class="button" @click="addRow"> Add Option </v-btn>
          </div>
        </v-form>
        <v-row justify="center">
          <v-btn class="button" @click="savemcq">Save</v-btn>
        </v-row>
      </span>
    </v-card>
    <div class="text-center">
      <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please Wait
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-if="imagesizeflaginputs" v-model="dialog_delete" persistent max-width="400px">
      <v-card>
        <v-container>
          <span v-if="imagesizeflaginputs">
            <v-col cols="12" xs="12" sm="12">
              <p class="slide">
                File size should be less than {{ imagesize_new }}KB!
              </p>
            </v-col>
          </span>
          <center>
            <v-btn class="button" text @click="dialog_delete = false">OK</v-btn>
          </center>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_delete1" persistent max-width="400px">
      <v-card>
        <v-container>
          <v-col cols="12" xs="12" sm="12" md="12">
            <p class="slide">
              File in
              <span v-for="(img, index) in imagetype_new" :key="index">
                {{ img.imagetype }}
              </span>
              Format!!!
            </p>
          </v-col>

          <center>
            <v-btn class="button" @click="dialog_delete1 = false">OK</v-btn>
          </center>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- show editor -->
    <v-row v-if="show_editor" justify="center" ref="textEditorSection">
      <v-col cols="12" sm="8" md="8">
        <v-card>
          <v-toolbar class="toolbar">
            <v-toolbar-title>Text Editor</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="show_editor = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <br />
          <v-row dense justify="center">
            <v-col cols="12" sm="7" md="7">
              <ckeditor v-model="textEditor" :config="editorConfig"></ckeditor>
            </v-col>
            <v-col cols="12" sm="3" md="3" v-if="textEditor">
              <span><v-icon class="icon-quick" title="Copy text"
                  @click="copy(textEditor)">mdi-content-copy</v-icon></span>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  props: {
    type: String,
    // chapter: String,  // changed to number
    chapter: Number,
    Level: Number,

    crs: Number,
  },
  data() {
    return {
      editorConfig: {
        height: "100px",
        extraPlugins: "mathjax",
        mathJaxLib:
          "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
      },
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search: null,
      overlay: false,
      crs_list: null,
      //crs: null,
      chapter_list: null,
      //chapter:null,
      iscorrect_01: null,
      iscorrect_02: null,
      qfile: null,
      // isapprove: true,
      weightage: 1,
      question: null,
      option_01: null,
      option_02: null,
      optfile1: null,
      optfile2: null,
      optionsize: 0,
      inputs: [],
      optionlist: null,
      question_size: null,
      imagesizeflaginputs: false,
      imagesizetypeinputs: false,
      imagesize: null,
      imageSizeFlag: false,
      imageSizeFlag1: false,
      imageSizeFlag2: false,
      imageTypeFlag: false,
      imageTypeFlag1: false,
      imageTypeFlag2: false,
      dialog_delete: false,
      dialog_delete1: false,
      dialog_zooimg: false,
      dialog_save: false,
      dialog_save_option: false,
      dialog_upload: false,
      imagesize_new: null,
      imagetype_new: null,
      show_editor: false,
      textEditor: "",
    };
  },
  updated: function () {
    this.$nextTick().then(() => {
      if (window.MathJax) {
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
          console.log("done")
        );
      }
    });
  },
  methods: {
    scrollToEditor() {
      this.$nextTick(() => {
        const editorSection = this.$refs.textEditorSection;
        if (editorSection) {
          editorSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    showEditor() {
      this.show_editor = true;
      this.scrollToEditor();
    },
    validateFile() {
      let file = this.qfile;
      let file_size = file.size;
      let file_name = this.qfile.name;
      let ext = file_name.split(".").pop();
      const data = {
        type: this.type,
      };
      axios
        .post("/QuizQuestionBank/validatefile", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.imagesize = res.data.imagesize;
            if (file_size > this.imagesize) {
              this.imageSizeFlag = true;
              this.qfile = null;
            } else {
              this.imageSizeFlag = false;
            }
            this.imagetype = res.data.imagetype;
            for (var i = 0; i < this.imagetype.length; i++) {
              if (ext == this.imagetype[i].imagetype) {
                this.imageTypeFlag = false;
                return;
              }
            }
            for (var i = 0; i < this.imagetype.length; i++) {
              if (ext != this.imagetype[i].imagetype) {
                this.imageTypeFlag = true;
                this.qfile = null;
                return;
              }
            }
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.onerror(error);
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        });
    },
    validateFileOptions(filename, index) {
      let file1 = filename;
      let invalid = "";
      let file_size1 = file1.size;
      let file_name1 = filename.name;
      let ext1 = file_name1.split(".").pop();
      const data = {
        type: this.type,
      };
      axios
        .post("/QuizQuestionBank/validatefile", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            console.log(res.data.imagesize);
            this.imagesize = res.data.imagesize;
            if (file_size1 > this.imagesize) {
              this.imagesizeflaginputs = true;
              this.dialog_delete = true;
              this.inputs[index].file = null;
            } else {
              this.imagesizeflaginputs = false;
              this.dialog_delete = false;
            }
            console.log(res.data.imagetype);
            this.imagetype = res.data.imagetype;

            for (var i = 0; i < this.imagetype.length; i++) {
              if (ext1 == this.imagetype[i].imagetype) {
                this.imagesizetypeinputs = false;
                this.dialog_delete1 = false;
                return;
              } else {
                this.imagesizetypeinputs = true;
                this.dialog_delete1 = true;

                invalid = "invalidfile";
              }
            }
            if (invalid == "invalidfile") {
              this.inputs[index].file = null;
            }
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.onerror(error);
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        });
    },
    copy(text) {
      navigator.clipboard.writeText(text);
      //   alert("Text copied to clipboard!!!");
      this.showSnackbar("#4caf50", "Text copied to clipboard!!!");
    },
    loadCard() { },
    savemcq() {
      var form = document.getElementById("profile_form");
      let formData = new FormData(form);
      if (
        (this.qfile == null && this.question == "") ||
        (this.qfile == null && this.question == null)
      ) {
        this.showSnackbar("#b71c1c", "Please Add The Question !!!"); // show snackbar
        return;
      }
      if (this.imagesizeflaginputs) {
        this.showSnackbar("#b71c1c", "Please check file size!!!"); // show snackbar
        return false;
      }
      if (this.imagesizetypeinputs) {
        this.showSnackbar("#b71c1c", "Please check file extension!!!"); // show snackbar
        return false;
      }
      var iscorrect = false;

      for (let i = 0; i < this.inputs.length; i++) {
        if (this.inputs[i].value == null || this.inputs[i].value == true) {
          this.inputs[i].value = true;
          iscorrect = true;
        }
      }
      if (iscorrect == false) {
        this.showSnackbar("#b71c1c", "Please select correct option..."); // show snackbar
        return;
      }
      var asc = 64;
      var correct;
      for (let i = 0; i < this.inputs.length; i++) {
        asc += 1;
        if (this.inputs[i].value == true) {
          correct = asc;
        }
        formData.append("opt_id", i);
        formData.append("optiscorrect", this.inputs[i].value);
        formData.append("opttext", this.inputs[i].text);
        let file = this.inputs[i].file;

        if (
          (this.inputs[i].text == "" && this.inputs[i].file == "") ||
          (this.inputs[i].text == null && this.inputs[i].file == null)
        ) {
          this.showSnackbar(
            "#b71c1c",
            "Either option text or option image file is compulsory please add..."
          ); // show snackbar
          return;
        }
      }

      formData.append("correct_char", correct);
      formData.append("qfile", this.qfile);
      // formData.append("optfile1", this.optfile1);
      // formData.append("optfile2", this.optfile2);
      formData.append("weightage", this.weightage);
      formData.append("question", this.question);
      // formData.append("option_01", this.option_01);
      // formData.append("option_02", this.option_02);
      // formData.append("isapprove", this.isapprove);
      // formData.append("iscorrect_01", this.iscorrect_01);
      formData.append("ch_id", this.chapter);
      formData.append("Level_id", this.Level);
      formData.append("crs_id", this.crs);
      formData.append("type", this.type);
      formData.append("from", "QB");

      //   if (this.qfile == null && this.question == "") {
      //     this.showSnackbar("#b71c1c", "Please Add The Question !!!"); // show snackbar
      //     return;
      //   }
      //   if (this.optfile1 == null && this.option_01 == "") {
      //     this.showSnackbar("#b71c1c", "Please Select Option 01 !!!"); // show snackbar
      //     return;
      //   }
      //   if (this.optfile2 == null && this.option_02 == "") {
      //     this.showSnackbar("#b71c1c", "Please Select Option 02 !!!");
      //     return;
      //   }
      this.dialog_upload = true;
      axios
        .post("/LiveClass/saveQuestionInBank", formData, {})
        .then((res) => {
          //   if (res.data.flagiscorrect == "notselected") {
          //     this.dialog_upload = false;
          //     this.showSnackbar("#b71c1c", "Please Select Correct Option!!!");
          //   }
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Saved Successfully...");
            this.dialog_upload = false;
            this.reset();
            this.addFirstTwoRows();
            this.getQuestionBank();
            this.optionsize = 2;

          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong !!!");
          this.dialog_upload = false;
        })
        .finally(() => {
          // this.isapprove = true;
        });
    },
    reset() {
      (this.weightage = 1),
        (this.question = null),
        (this.qfile = null),
        (this.iscorrect_01 = null),
        (this.optfile1 = null),
        (this.optfile2 = null),
        (this.option_01 = null),
        (this.option_02 = null);
      this.inputs = [];
    },

    addRow() {
      this.inputs.push({
        value: "",
        text: "",
        file: null,
      });
      this.optionsize++;
    },
    addFirstTwoRows() {
      this.inputs.push({
        value: "",
        text: "",
        file: null,
      });
      this.optionsize++;

      this.inputs.push({
        value: "",
        text: "",
        file: null,
      });
      this.optionsize++;
    },
    deleteRow(index) {
      this.inputs.splice(index, 1);
      this.optionsize--;
    },
    radio(index) {
      // alert(index)
      //   if (index == "b" || index == "a") {

      //     for (let i = 0; i < this.inputs.length; i++) {
      //       this.inputs[i].value = false;
      //     }
      //   } else {

      //     this.iscorrect_01 = false;
      //     for (let i = 0; i < this.inputs.length; i++) {
      //       if (i == index) {
      //         if (this.inputs[i].inputs == false) {
      //           this.inputs[i].value = true;
      //         }
      //       } else {
      //         this.inputs[i].value = false;
      //         this.iscorrect_01 = false;
      //       }
      //     }
      //   }
      for (let i = 0; i < this.inputs.length; i++) {
        if (i == index) {
          if (this.inputs[i].inputs == false) {
            this.inputs[i].value = true;
          }
        } else {
          this.inputs[i].value = false;
        }
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getCourse() {
      axios
        .post("/QuizQuestionBank/getCourse")
        .then((res) => {
          this.crs_list = res.data.crs_list;
        })
        .catch((error) => {
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => {
          //close loader
        });
    },
    getchapter() {
      const data = {
        crs_id: this.crs,
      };
      axios
        .post("/QuizQuestionBank/getchapter", data)
        .then((res) => {
          if (res.data.flag == "NO") {
            this.showSnackbar(
              "#b71c1c",
              "Please add chapter for selected course !!!"
            );
            return;
          } else {
            this.chapter_list = res.data.chapter_list;
          }
        })
        .catch((error) => {
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => {
          //close loader
        });
    },
    getQuestionBank() {
      const data = {
        crs_id: this.crs,
        ch_id: this.chapter,
        Level_id: this.Level,
        type: this.type,
      };
      axios
        .post("/QuizQuestionBank/getQuestionBank", data)
        .then((res) => {
          this.question_size = res.data.question_size;
          this.imagesize_new = res.data.imagesize / 1000;
          this.imagetype_new = res.data.imagetype;
        })
        .catch((error) => {
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => {
          //close loader
        });
    },
    getdifficultylevel() {
      const data = {

      };
      axios
        .post("/QuizQuestionBank/getdifficultylevel", data)
        .then((res) => {
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", "Please add Level..!!!");
            return
          }
          else {
            this.Level_list = res.data.difficulty_level_list;
          }
        })
        .catch((error) => {
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => {
          //close loader
        });
    },
  },
  mounted() {
    // alert(this.chapter)
    this.getQuestionBank();
    this.addFirstTwoRows();
  },
};
</script>
<style scoped>
.radiospace {
  margin: 0.5rem !important;
  padding: 0%;
}

.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}
</style>
